import React, { /* useState,*/ useRef, useEffect, useState } from "react";
// import { Button } from "@ts-digital/vrc";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import useChangeAccountant from "../../customHooks/useChangeAccountant";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { FormattedMessage, useIntl } from "react-intl";
import StudioCertificationForm from "./certificationForm";
import { studioStatusColors, studioStatuses } from "./utils";
import { useLocation, useNavigate } from "react-router-dom";
import { getSettingsCompany, getSettingsCompanyForUser } from "../../store/actions/permissions";

const StudioSelector = (props) => {
  const { closeStudioModal } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const main = useSelector((state) => state.main);
  const studio = useSelector((state) => state.studio);
  const user = useSelector((state) => state.user);
  // const [studioSelected, setStudioSelected] = useState(main.accountantIdSelected);
  const [studioToValidate, setStudioToValidate] = useState(null);

  const intl = useIntl();

  const dispatch = useDispatch();

  const pageRef = useRef();

  useEffect(() => {
    if (!pageRef?.current) return undefined;
    let ps = new Scrollbar(pageRef.current, { wheelPropagation: true });
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [pageRef?.current]);

  const { changeAccountantSelected } = useChangeAccountant();

  const hideStateField = (status) => {
    return user?.profile?.language === "es-ES" && studioStatuses[status] === "validation.status.UNVERIFIABLE";
  };

  if (studioToValidate) {
    return (
      <StudioCertificationForm
        data={studio?.list?.find((x) => x?.id === studioToValidate)}
        id={studioToValidate}
        onCancel={() => setStudioToValidate(null)}
        onConfirm={() => {
          window.location.reload();
        }}
      />
    );
  }
  return (
    <div className="containerStudios" ref={pageRef}>
      <div className="titleStudioSelector">
        <FormattedMessage id="main.studioSelector.title" />
      </div>
      <div className="subtitleStudioSelector">
        <FormattedMessage id="main.studioSelector.title2" />
      </div>
      <div className="row-responsive">
        <div className="studioList-container">
          <div className="studioList">
            {studio?.list?.map((std) => {
              return (
                <div key={"studioList_" + std.id} className="dbx-vapor-card">
                  <div className="dbx-vapor-card-title">
                    <div style={{ fontWeight: 600 }}>{std.ragioneSociale}</div>
                    {!hideStateField(std?.additionalData?.status?.status) && (
                      <div className="dbx-vapor-card-icons">
                        {std?.additionalData?.status.status !== "VALIDATED" && std?.additionalData?.status.status !== "UNVERIFIABLE_PENDING_VALIDATE" && (
                          <span className="dbx-vapor-card-icon">
                            <a onClick={() => setStudioToValidate(std.id)} style={{ display: "", color: "var(--status-alert2)" }}>
                              <i aria-label="icona: safety" className="anticon anticon-safety">
                                <svg
                                  viewBox="0 0 1024 1024"
                                  focusable="false"
                                  className=""
                                  data-icon="safety"
                                  width="1em"
                                  height="1em"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path d="M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z"></path>
                                  <path d="M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z"></path>
                                </svg>
                              </i>
                            </a>
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="dbx-vapor-card-data">
                    {!hideStateField(std?.additionalData?.status?.status) && (
                      <>
                        <FormattedMessage id="validation.data.status" />:
                        <strong style={{ color: studioStatusColors[std?.additionalData?.status?.status] || "rgb(73, 74, 76)" }}>
                          <FormattedMessage id={studioStatuses[std?.additionalData?.status?.status] || std?.additionalData?.status?.status} />
                        </strong>
                      </>
                    )}
                    <FormattedMessage id="validation.data.taxId" />:<strong>{std.codiceFiscale}</strong>
                    <FormattedMessage id="validation.data.vatNumber" />:<strong>{std.partitaIva}</strong>
                    <FormattedMessage id="validation.data.type" />:
                    <strong>{intl.formatMessage({ id: `profile.types.${std.classifier === "STUDIO" ? "accountant" : "company"}` })?.toUpperCase()}</strong>
                  </div>
                  <a
                    onClick={() => {
                      // if (std?.additionalData?.status?.status !== "VALIDATED") {
                      //   return null;
                      // }
                      if (location.pathname === "/choose-studio") {
                        dispatch(getSettingsCompany());
                        dispatch(
                          getSettingsCompanyForUser(
                            main.companyUuidSelected,
                            user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id,
                            main.accountantUuidSelected
                          )
                        );
                      }
                      changeAccountantSelected(std?.id);
                      closeStudioModal();
                      if (location.pathname === "/choose-studio") {
                        navigate("/");
                      }
                      return null;
                    }}
                  >
                    <div className={"dbx-vapor-card-actions"}>
                      <FormattedMessage id="validation.actions.select" />
                      <i aria-label="icona: right-circle" className="anticon anticon-right-circle">
                        <svg
                          viewBox="64 64 896 896"
                          focusable="false"
                          className=""
                          data-icon="right-circle"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z"></path>
                          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
                        </svg>
                      </i>
                    </div>
                  </a>
                </div>
              );
              /* return (
              <div
                className="studioContainer"
                key={"studioContainer" + std.id}
                onClick={() => {
                  setStudioSelected(std.id);
                }}
              >
                <div
                  className={
                    studioSelected && std.id === studioSelected
                      ? "radioSelector active"
                      : "radioSelector"
                  }
                  key={"radioSelector" + std.id}
                />
                <div
                  className={
                    studioSelected && studioSelected === std.id
                      ? "studioLabel active"
                      : "studioLabel"
                  }
                  key={"studioLabel" + std.id}
                >
                  {std.ragioneSociale}
                </div>
              </div>
            );*/
            })}
          </div>
          {/* studioSelected ? (
          <Button
            style={{ fontSize: "14px" }}
            kind={"primary"}
            colorScheme={"ghost"}
            className={"enterBtn"}
            onClick={() => {
              changeAccountantSelected(studioSelected);
              closeStudioModal();
            }}
          >
            AVANTI
          </Button>
          ) : null*/}
        </div>
      </div>
    </div>
  );
};

export default StudioSelector;
